export default {
	// Config
	apiKey: "AIzaSyAdRkRKu9XTuq8OEU7Kn_6UrjO3Vd46RIU",
  authDomain: "roadtrip-mytrace.firebaseapp.com",
  projectId: "roadtrip-mytrace",
  storageBucket: "roadtrip-mytrace.firebasestorage.app",
  messagingSenderId: "831989651663",
  appId: "1:831989651663:web:59a4e34579a35f99cc7fba"
};
